import type { TiptapCollabProvider } from '@tiptap-pro/provider';
import { Extension } from '@tiptap/core';

declare module '@tiptap/core' {
    interface Storage {
        collaborationNodePresence?: {
            provider: TiptapCollabProvider | null;
        };
    }
}

export interface CollaborationNodePresenceOptions {
    provider: TiptapCollabProvider | null;
}

export const CollaborationNodePresence = Extension.create<CollaborationNodePresenceOptions>({
    name: 'collaborationNodePresence',

    addOptions() {
        return {
            provider: null,
        };
    },

    addStorage() {
        return {
            provider: this.options.provider,
        };
    },
});

export default CollaborationNodePresence;
